import { render, staticRenderFns } from "./SmOwCheckboxQuestion.vue?vue&type=template&id=92fb024e&"
import script from "./SmOwCheckboxQuestion.vue?vue&type=script&lang=ts&"
export * from "./SmOwCheckboxQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports